import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from './../../modules/auth/_services/auth.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  private userDetails: { id: string; status: 'loggedin' | 'nonloggedin' } = { id: '', status: 'nonloggedin' };
  private accessToken: string | null = null;

  constructor(
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.authService.user$.subscribe(user => {
      this.userDetails = user ? this.authService.getUserDetails() : { id: '', status: 'nonloggedin' };
      this.accessToken = user ? this.authService.accessToken : null;
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const id = this.userDetails?.id || '';
    const status = this.userDetails?.status || 'guest';

    let headers = request.headers.set('Access-Control-Allow-Origin', '*');

    if (status === 'loggedin' && id) {
      headers = headers.set('User-ID', id);
    } else if (id) {
      headers = headers.set('Session-ID', id);
    }

    const isExternalWordPressRequest = request.url?.includes('blogs.tendershark.com');

    if (!isExternalWordPressRequest) {
      if (isPlatformBrowser(this.platformId)) {
        const pageUrl = typeof window !== 'undefined' && window.location?.href ? window.location.href : '';
        if (pageUrl) {
          headers = headers.set('Page-URL', pageUrl);
        }
      }
    }

    if (isPlatformBrowser(this.platformId) && this.accessToken) {
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
    }

    if (request.url?.includes('seo-content') || request.url?.includes('tenderStats') || request.url?.includes('indexing')) {
      request = request.clone({ headers });
    } else if (request.url?.includes('details') || request.url?.includes('tender/view/')) {
      headers = headers.set('Page-URL', request.url);
      request = request.clone({ headers });
    } else {
      request = request.clone({ headers });
    }

    return next.handle(request).pipe(
      catchError((error: any) => this.handleError(error)),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status === 401) {
      if (isPlatformBrowser(this.platformId)) {
        console.warn('401 Unauthorized - logging out user.');
        this.authService.logout();
      }
    }
    return throwError(error);
  }

}
